import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent {
 
  @Input() accordionItems: any[];

  // Border value: accordion-bordered
  @Input() bordered: boolean = false;

  // No gutter value: accordion-no-gutter
  @Input() noGutter: boolean = false;

  // No gutter and border value: accordion-no-gutter accordion-bordered
  @Input() noGutterBordered: boolean = false;

  // Start indicator value: accordion-start-indicator
  @Input() startIndicator: boolean = false;

  // With icon value: accordion-with-icon
  @Input() withIcon: boolean = false;

  // Header background value: accordion-header-bg
  @Input() headerBg: boolean = false;

  // Solid background value: accordion-solid-bg
  @Input() solidBg: boolean = false;

  // Active header value: accordion-active-header
  @Input() activeHeader: boolean = false;

  // Header shadow and rounded value: accordion-header-shadow and accordion-rounded
  @Input() headerShadow: boolean = false;


  @Input() rounded: boolean = false;

  // Stylishly rounded value: accordion-rounded-stylish
  @Input() roundedStylish: boolean = false;

  // Gradient value: accordion-gradient
  @Input() gradient: boolean = false;


}
